<template>
  <div id="app">
    <div class="over-all" v-if="isSetting"></div>
    <router-view />
  </div>
</template>

<script>
import configMixin from "@/mixin/config";

export default {
  name: "App",
  components: {},
  mixins: [configMixin],
};
</script>
<style lang="scss" scoped>
//#app {
//  height: 100%;
//}
</style>
